var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia } from '@joint/plus';
import { LABEL_OFFSET } from '../app';
var BORDER_RADIUS = 5;
var Member = /** @class */ (function (_super) {
    __extends(Member, _super);
    function Member() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [
            {
                tagName: 'rect',
                selector: 'body'
            },
            {
                tagName: 'text',
                selector: 'name'
            },
            {
                tagName: 'rect',
                selector: 'labelBg'
            },
            {
                tagName: 'text',
                selector: 'label'
            }
        ];
        return _this;
    }
    Member.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'teamOrder.Member', attrs: {
                body: {
                    width: 'calc(w)',
                    height: 'calc(h)',
                    fill: '#ededed',
                    strokeWidth: 0,
                    rx: BORDER_RADIUS,
                    pointerEvents: 'all'
                },
                name: {
                    fontFamily: 'sans-serif',
                    textVerticalAnchor: 'middle',
                    textAnchor: 'left',
                    fill: '#22242A',
                    y: 'calc(0.5 * h)',
                    x: LABEL_OFFSET,
                    pointerEvents: 'none'
                },
                labelBg: {
                    width: 'calc(h)',
                    height: 'calc(h)',
                    x: 'calc(w - calc(h))',
                    rx: BORDER_RADIUS,
                    pointerEvents: 'none'
                },
                label: {
                    fontFamily: 'sans-serif',
                    textVerticalAnchor: 'middle',
                    textAnchor: 'middle',
                    fill: '#FFFFFF',
                    y: 'calc(0.5 * h)',
                    x: 'calc(w - calc(0.5 * h))',
                    pointerEvents: 'none'
                }
            } });
    };
    return Member;
}(dia.Element));
export { Member };
